const BandaMass = [
    {
    id: 1,
    title: 'apple smash  250мл',
    isNew: true,
    price: '230 грн',
    src: require('../img/appleSmash.png'),
    text: `бурбон буллет,  
куантро,
сироп яблоко,
Сік лимона, 
изи фом`,
  },
  {
    id: 2,
    title: 'Tropic menta  250мл',
    isNew: true,
    price: '220 грн',
    src: require('../img/TropicMenta.png'),
    text: `Текіла,
куантро, 
лайм,
мята,
7ап`,
  },
  {
    id: 3,
    title: 'orange flavor  250мл',
    isNew: true,
    price: '230 грн',
    src: require('../img/orangeFlavor.png'),
    text: `гордонс оранж, 
сироп бузина,
лимон,
куантро,
тоник`,
  },
  {
    id: 4,
    title: 'inferno 200мл',
    isNew: true,
    price: '225 грн',
    src: require('../img/inferno.png'),
    text: `Текіла,
апероль,
сок грейфрута,
лайм,
сахар сироп`,
  },
  {
    id: 5,
    title: 'juice sun 150мл',
    isNew: true,
    price: '200 грн',
    src: require('../img/juicesun.png'),
    text: `гордонс оранж,
лайм фреш,
 сироп мед,
ликер вишни,
ангостура`,
  },
  {
    id: 6,
    title: 'sweet sin 150мл',
    isNew: true,
    price: '230 грн',
    src: require('../img/sweetsin.png'),
    text: `бейлис,
ликер смородина,
Ванільна горілка ,
сироп земляника,
Вершки`,
  },
  {
    id: 7,
    title: 'Black Velvet 150мл',
    isNew: true,
    price: '210 грн',
    src: require('../img/BlackVelvet.png'),
    text: `ром дарк 
ликер кофе,
ликер смородина,
лимон (фреш),
ангостура`,
  },
  {
    id: 8,
    title: 'green breeze 250мл',
    isNew: true,
    price: '225 грн',
    src: require('../img/deepbasil.png'),
    text: `джин,
сок лимона,
 сироп бузина,
м'ята,
просеко`,
  },
  //     {
  //         id:1,
  //         title:"Hot aperol 300мл ",
  //         isNew: true,
  //         price:"190 грн",
  //         isHot: true,
  //         src: require('../img/Hotaperol.png'),
  //         text:`Апероль,
  // Дон симон біле сухе,
  // Сік апельсин,
  // Сироп медовий`,
  //     },
  //     {
  //         id:2,
  //         title:"Black maister 250мл",
  //         isNew: true,
  //         isHot: true,
  //         price:"180 грн",
  //         src: require('../img/Blackmaister.png'),
  //         text:`Чорний чай,
  // Сік апельсин,
  // Сік лимон,
  // Егермайстер,
  // Корица сироп`,
  //     },
  {
    id: 9,
    title: 'Пряне яблуко  250мл',
    // isNew: true,
    price: '215 грн',
    src: require('../img/pryaneYabluko.png'),
    text: `Ром Блек Спайсед, 
Текіла Харана бьянка, 
сироп яблоко, 
Сік лимона, 
Спрайт`,
  },
  {
    id: 10,
    title: 'keep it honney  200мл',
    // isNew: true,
    price: '235 грн',
    src: require('../img/keepithonney.png'),
    text: `Джек медовий, 
Сироп кориця,  
Сік яблочний,  
Сік лимон`,
  },
  //     {
  //         id:5,
  //         title:"Level up  150мл",
  //         isNew: true,
  //         price:"180 грн",
  //         src: require('../img/Levelup.png'),
  //         text:`Джин,
  // Сироп Апероль,
  // Сік лимона,
  // ізі фом`,
  //     },
  {
    id: 11,
    title: 'Chunky  200мл',
    // isNew: true,
    price: '215 грн',
    src: require('../img/Chunky.png'),
    text: `Джин, 
Сік яблоко, 
Сироп кориці, 
Лимон`,
  },
  //     {
  //         id:7,
  //         title:"captain sweetie 250мл",
  //         isNew: true,
  //         isHot: true,
  //         price:"170 грн",
  //         src: require('../img/kepsweety.png'),
  //         text:`золотий ром,
  // Сироп кориці
  // Сік вишни,
  // Прянощі`,
  //     },
  {
    id: 12,
    title: 'Чіназез 450мл ',
    // isNew: true,
    price: '250 грн',
    src: require('../img/chinazez.png'),
    text: 'ром золотий, егермайстер, кокосовий лікер, лимонний сік, вишневий сік',
  },
  {
    id: 13,
    title: 'Працьовитий ротик 200мл ',
    // isNew: true,
    price: '220 грн',
    src: require('../img/pracovrotik.png'),
    text: 'текіла, сироп блю кюрасао, лікер блю кюрасао, бейліс, ананасовий сік',
  },
  {
    id: 14,
    title: 'Грінні 250мл ',
    // isNew: true,
    price: '220 грн',
    src: require('../img/greeny.png'),
    text: 'ром золотий, лікер амаретто, сік яблучний, лимонний сік',
  },
  {
    id: 15,
    title: 'Джеррі 350мл ',
    // isNew: true,
    price: '210 грн',
    src: require('../img/jarry.png'),
    text: 'вишневий лікер, горілка, сік грейпфрут, тонік',
  },
  {
    id: 16,
    title: 'Simba 350мл ',
    // isNew: true,
    price: '210 грн',
    src: require('../img/simba.png'),
    text: 'ром золотий, егермайстер, лікер банан, ванільний сироп, ананасовий сік',
  },
  // {
  //     id:14,
  //     title:"Навколо світу 250мл ",
  //     isNew: true,
  //     price:"180 грн",
  //     src: require('../img/navkolosvitu.png'),
  //     text:"ром золотий, лікер апельсиновий, ангостура, ананасовий сироп, лимонний сік, апельсин, м'ята",
  // },
  {
    id: 17,
    title: 'Pussy kiss 250мл ',
    // isNew: true,
    price: '225 грн',
    src: require('../img/pussykiss.png'),
    text: 'джин, вишневий лікер, полуничний сироп, ананасовий сік',
  },
  {
    id: 18,
    title: 'Summer kiss 250мл ',
    // isNew: true,
    price: '215 грн',
    src: require('../img/summerkiss.png'),
    text: 'текіла, апероль, полуничний сироп, лимонний сік, ізі фом',
  },
  {
    id: 19,
    title: 'Фієста 350мл ',
    // isNew: true,
    price: '200 грн',
    src: require('../img/fiesta.png'),
    text: 'золотий ром, джин оранж, лікер амаретто, лікер кокос, ананасовий сік, лимонний сік',
  },

  // {
  //     id:18,
  //     title:"Скриптоніт 120мл",
  //     price:"140 грн",
  //     src: require('../img/skrip.webp'),
  //     text:"ром золотий, н/к «Coffee», сироп шоколадний, лікер вершковий, вершки",
  // },

  // {
  //     id:19,
  //     title:"Елджей 250мл",
  //     price:"150 грн",
  //     src: require('../img/elj.webp'),
  //     text:"ром золотий, горілка, н/к «Limonchella», сироп персиковий, сік ананасовий",
  // },
  {
    id: 20,
    title: 'cherry sour 250мл ',
    price: '230 грн',
    src: require('../img/cherysour.png'),
    text: 'егермайстер, сік лимона, сироп вишневий, ізі фом',
  },
  //{
  //id:21,
  //title:"Бабуся не проти 350мл",
  //price:"155 грн",
  //src: require('../img/granma.webp'),
  //text:"горілка, н/к «Currant», тонік, сік вишневий, сік лимонний",
  // //},
  // {
  //     id:22,
  //     title:"Файний джин 250мл",
  //     price:"160 грн",
  //     src: require('../img/fayniyjin.png'),
  //     text:"гордон`c середземноморський апельсин, тонік, апельсин",
  // },

  // {
  //     id:23,
  //     title:"Пекельна мала 350мл",
  //     price:"200 грн",
  //     src: require('../img/pekelnamala.png'),
  //     text:"гордон`c середземноморський апельсин, лимонний сік, сироп гренадін",
  // },
  // {
  //     id:24,
  //     title:"Німецька ніч 350мл",
  //     price:"210 грн",
  //     src: require('../img/noch.webp'),
  //     text:"ром золотий, jagermaister, амарето лікер, сік лимона, cахарний сироп, пепсі ",
  // },
  // {
  //     id:25,
  //     title:"Жіноча спокуса 350мл",
  //     price:"190 грн",
  //     src: require('../img/spokusa.webp'),
  //     text:"ром золотий, самбука, сік персиковий, сік ананасовий",
  // },
  // {
  //     id:26,
  //     title:"Азія мінор айс ті 450мл",
  //     price:"200 грн",
  //     src: require('../img/azia.webp'),
  //     text:"горілка, ром золотий, джин, лікер диня, сік лимона, 7up",
  // },
  // {
  //    id:27,
  //  title:"Jager Coffe 120мл",
  //  price:"165 грн",
  //  src: require('../img/jagcof.webp'),
  //   text:"горілка, jagermaister, кавовий лікер, сироп грінадін",
  // },

  // {
  //     id:28,
  //     title:"Джуніор 350мл",
  //     price:"190 грн",
  //     src: require('../img/jun.webp'),
  //     text:"віскі белс, лікер персик, сік лимона, цукровий сироп, сік яблучний",
  // },
  // {
  //     id:29,
  //     title:"Sunset 350мл",
  //     price:"190 грн",
  //     src: require('../img/sunset.webp'),
  //     text:"горілка, ром золотий, джин, лікер персиковий, сік лимонний, цукровий сироп, сік апельсиновий, сироп грінадін",
  // },
];

export default BandaMass;
